import DisabledNodesParentTreeNode from "./DisabledNodesParentTreeNode";
import TreeNode from "./TreeNode";

export default class DisabledUsersParentTreeNode extends DisabledNodesParentTreeNode {
    constructor(parentId) {
        super("du", parentId);
    }

    getType() {
        return TreeNode.TYPE_DISABLED_USERS_PARENT
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/DisabledUsersParentTreeNode.js